/**
 * Settings store — nanostores atom over persistent GameSettings.
 * 面向初级用户（一键预设）与中级用户（全参数定制）的唯一数据通道。
 */
import { atom, computed } from 'nanostores';
import {
  DEFAULT_SETTINGS,
  DEFAULT_THEME,
  QUALITY_TIERS,
  THEMES,
  loadSettings,
  saveSettings,
  type GameSettings,
  type QualityTier,
  type ThemePreset,
} from '@shared/config/theme';

export const $settings = atom<GameSettings>(loadSettings());

export const $theme = computed($settings, (s): ThemePreset => THEMES[s.themeId] ?? DEFAULT_THEME);

export const $quality = computed($settings, (s): QualityTier => QUALITY_TIERS[s.quality]);

export function updateSettings(patch: Partial<GameSettings>): void {
  const next: GameSettings = { ...$settings.get(), ...patch };
  $settings.set(next);
  saveSettings(next);
}

export function resetSettings(): void {
  const next: GameSettings = { ...DEFAULT_SETTINGS };
  $settings.set(next);
  saveSettings(next);
}
